// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-list {
  min-height: unset;
  height: auto;
}

.filter-input {
  --background: rgba(255, 255, 255, 0.15);
  --color: var(--ion-color-contrast);
  --placeholder-color: rgba(255, 255, 255, 0.6);
  --placeholder-opacity: 1;
  --padding-start: 6px;
  --padding-end: 6px;
  --padding-top: 4px;
  --padding-bottom: 4px;
  border-radius: 6px;
  font-size: 0.78rem;
  min-height: 30px;
}
.filter-input::part(native) {
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.25);
}
.filter-input:hover::part(native) {
  border-color: rgba(255, 255, 255, 0.5);
}
.filter-input:focus-within::part(native) {
  border-color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/app/_components/spedizioni/spedizioni-locali-list/spedizioni-locali-list.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,uCAAA;EACA,kCAAA;EACA,6CAAA;EACA,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,kBAAA;EACA,2CAAA;AACJ;AAEE;EACE,sCAAA;AAAJ;AAGE;EACE,sCAAA;EACA,qCAAA;AADJ","sourcesContent":[".header-list {\n  min-height: unset;\n  height: auto;\n}\n\n.filter-input {\n  --background: rgba(255, 255, 255, 0.15);\n  --color: var(--ion-color-contrast);\n  --placeholder-color: rgba(255, 255, 255, 0.6);\n  --placeholder-opacity: 1;\n  --padding-start: 6px;\n  --padding-end: 6px;\n  --padding-top: 4px;\n  --padding-bottom: 4px;\n  border-radius: 6px;\n  font-size: 0.78rem;\n  min-height: 30px;\n\n  &::part(native) {\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.25);\n  }\n\n  &:hover::part(native) {\n    border-color: rgba(255, 255, 255, 0.5);\n  }\n\n  &:focus-within::part(native) {\n    border-color: rgba(255, 255, 255, 0.8);\n    background: rgba(255, 255, 255, 0.25);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
